module.exports = __webpack_public_path__ + "static/media/dispenser-view.4e1cf2a0.jpg";